export const doCheckout = async (payload: any) => {
  const response = await fetch(`${process.env.REACT_APP_BASE_API}/api/stripe/checkout-subscription`, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  return await response.json();
};
